/* AKM: when the colour swatch changes, reload the product gallery so it only shows that colour's images.
   Needs the AKM version of snippets/product-media.liquid (it adds data-akm-color to the gallery). */
(function () {
  if (window.__akmColorGallery) return;
  window.__akmColorGallery = true;

  var token = 0;

  function handleize(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function galleryFor(sectionId) {
    return document.querySelector('product-gallery-media[id^="productmedia-' + sectionId + '"]');
  }

  function update(picker) {
    var variant = picker.currentVariant;
    var sectionId = picker.dataset.section;
    var gallery = galleryFor(sectionId);
    var url = picker.dataset.url;
    if (!variant || !gallery || !url) return;

    var colorIndex = parseInt(gallery.dataset.akmColorIndex, 10);
    if (isNaN(colorIndex) || colorIndex < 0) return;                 // product has no colour option

    var color = handleize(variant.options && variant.options[colorIndex]);
    if (!color || color === gallery.dataset.akmColor) return;        // colour did not change (for example a size change)

    var current = ++token;
    gallery.style.transition = 'opacity .2s ease';
    gallery.style.opacity = '0.4';

    var requestSection = picker.dataset.originalSection || sectionId;
    fetch(url.split('?')[0] + '?variant=' + variant.id + '&section_id=' + requestSection)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        if (current !== token) return;                                // a newer click replaced this request
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('product-gallery-media[id^="productmedia-' + sectionId + '"]');
        var old = galleryFor(sectionId);
        if (fresh && old) {
          old.replaceWith(fresh);                                     // the new gallery starts its own slider
          if (window.akmLightbox) window.akmLightbox.init();          // keep the zoom popup working
        } else if (old) {
          old.style.opacity = '';
        }
      })
      .catch(function () {
        var old = galleryFor(sectionId);
        if (old) old.style.opacity = '';
      });
  }

  document.addEventListener('change', function (event) {
    var picker = event.target.closest && event.target.closest('variant-set-option');
    if (!picker || picker.closest('product-card') || picker.closest('quick-view-drawer')) return;
    setTimeout(function () { update(picker); }, 0);                   // let the theme update its current variant first
  });
})();